<div class="settings-shell">
    <header class="page-header">
        <div>
            <p class="eyebrow">Settings</p>
            <h1>Bank Account Settings</h1>
            <p class="subtitle">Manage imported bank accounts, sync behavior, and bookkeeping defaults.</p>
        </div>
        <div class="header-actions">
            <button mat-stroked-button routerLink="/settings">
                <mat-icon>arrow_back</mat-icon>
                All settings
            </button>
            <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving || !accounts.length">
                <mat-icon>save</mat-icon>
                {{ isSaving ? 'Saving...' : 'Save all changes' }}
            </button>
        </div>
    </header>

    <section class="settings-card create-card">
        <div class="section-heading">
            <div>
                <h2>Add Account</h2>
                <p>Create a new bank account record for feed imports and transaction routing.</p>
            </div>
        </div>

        <div class="form-grid compact">
            <mat-form-field appearance="outline">
                <mat-label>Account name</mat-label>
                <input matInput [(ngModel)]="newAccountName" placeholder="Main operating account">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Account number</mat-label>
                <input matInput [(ngModel)]="newAccountNumber" placeholder="123456789">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Category</mat-label>
                <mat-select [(ngModel)]="newAccountCategory">
                    <mat-option *ngFor="let option of categoryOptions" [value]="option.value">
                        {{ option.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="section-actions">
            <button mat-raised-button color="primary" (click)="add()" [disabled]="!canAddAccount() || isAdding">
                <mat-icon>add</mat-icon>
                {{ isAdding ? 'Adding...' : 'Add account' }}
            </button>
        </div>
    </section>

    <section class="settings-card">
        <div class="section-heading">
            <div>
                <h2>Configured Accounts</h2>
                <p>Account numbers are used as identifiers and are currently read-only after creation.</p>
            </div>
            <span class="count">{{ accounts.length }} {{ accounts.length === 1 ? 'account' : 'accounts' }}</span>
        </div>

        <div class="empty-state" *ngIf="accounts.length === 0">
            No bank accounts have been configured yet.
        </div>

        <div class="account-list" *ngIf="accounts.length > 0">
            <section class="account-card" *ngFor="let account of accounts">
                <div class="account-header">
                    <div>
                        <h3>{{ account.name || 'Untitled account' }}</h3>
                        <p>{{ account.accountNumber }}</p>
                    </div>
                    <button mat-stroked-button color="warn" (click)="delete(account)">
                        <mat-icon>delete</mat-icon>
                        Delete
                    </button>
                </div>

                <div class="form-grid">
                    <mat-form-field appearance="outline">
                        <mat-label>Account name</mat-label>
                        <input matInput [(ngModel)]="account.name">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Account number</mat-label>
                        <input matInput [ngModel]="account.accountNumber" readonly>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Display order</mat-label>
                        <input matInput type="number" [(ngModel)]="account.order">
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Category</mat-label>
                        <mat-select [(ngModel)]="account.category">
                            <mat-option *ngFor="let option of categoryOptions" [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="toggles">
                    <mat-checkbox [(ngModel)]="account.ignoreCredits">Ignore credits from bank sync</mat-checkbox>
                    <mat-checkbox [(ngModel)]="account.ignoreDebits">Ignore debits from bank sync</mat-checkbox>
                    <mat-checkbox [(ngModel)]="account.automaticallyAddVAT">Auto-calculate GST on imported transactions</mat-checkbox>
                </div>

                <mat-form-field appearance="outline" class="notes-field">
                    <mat-label>Monthly notes</mat-label>
                    <textarea matInput rows="3" [(ngModel)]="account.monthlyNotes" placeholder="Optional notes for reconciliation or invoicing"></textarea>
                </mat-form-field>
            </section>
        </div>
    </section>
</div>
